<template>
  <!-- <div id="main-wrapper pt-0" class="show"> -->
  <div class="landing_page">
    <div class="homepage">
      <div class="container">
        <el-card class="box-card" style="margin-top: 20px; padding-top: 20px">
          <el-header style="text-align: center">
            <h1>Company information authentication</h1>
          </el-header>
          <div class="row">
            <div class="col-xl-12 col-lg-12" style="margin-top: 40px">
              <section>
                <el-steps
                  :active="activeStep"
                  align-center
                  finish-status="success"
                >
                  <el-step title="General"></el-step>
                  <el-step title="Representives"></el-step>
                  <el-step title="Beneficial Owners"></el-step>
                  <el-step title="Documentation"></el-step>
                  <el-step title="Banking Info"></el-step>
                  <el-step title="Questionnaire"></el-step>
                </el-steps>
              </section>
            </div>
          </div>
          <div class="row">
            <div
              class="col-xl-12 col-lg-12"
              style="margin-left: 10%; margin-top: 40px"
            >
              <el-form
                ref="elForm"
                :model="formData"
                :rules="rules"
                size="medium"
                label-width="100px"
                label-position="top"
              >
                <el-row>
                  <el-col :span="20">
                    <el-col :span="12">
                      <el-col :span="22">
                        <el-form-item
                          label="Entity Legal Name"
                          prop="s1_entity_legal_name"
                        >
                          <el-input
                            v-model="formData.s1_entity_legal_name"
                            placeholder="e.g.ABC Inc."
                            clearable
                            :style="{ width: '100%' }"
                          >
                          </el-input>
                        </el-form-item>
                      </el-col>
                    </el-col>
                    <el-col :span="12">
                      <el-col :span="22">
                        <el-form-item
                          label="Legal Entity Identifier(if applicable)"
                          prop="s1_entity_legal_id"
                        >
                          <el-input
                            v-model="formData.s1_entity_legal_id"
                            placeholder="EIN if this is a U.S. entity"
                            clearable
                            :style="{ width: '100%' }"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-col>
                  </el-col>
                  <el-col :span="20">
                    <el-row>
                      <el-col :span="6">
                        <el-col :span="22">
                          <el-form-item label="Country" prop="s1_country">
                            <el-select
                              v-model="formData.s1_country"
                              placeholder="Select or search country"
                              clearable
                              :style="{ width: '100%' }"
                            >
                              <el-option
                                v-for="(item, index) in countryOptions()"
                                :key="index"
                                :label="item.label"
                                :value="item.value"
                                :disabled="item.disabled"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                      </el-col>
                      <el-col :span="6">
                        <el-col :span="22">
                          <el-form-item label="City" prop="s1_city">
                            <el-input
                              v-model="formData.s1_city"
                              placeholder="please enter city"
                              clearable
                              :style="{ width: '100%' }"
                            >
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-col>
                      <el-col :span="12">
                        <el-row>
                          <el-col :span="22">
                            <el-form-item
                              label="Business Address"
                              prop="s1_biz_address"
                            >
                              <el-input
                                v-model="formData.s1_biz_address"
                                placeholder="please enter addres"
                                clearable
                                :style="{ width: '100%' }"
                              ></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="20">
                    <el-row>
                      <el-col :span="6">
                        <el-row>
                          <el-col :span="22">
                            <el-form-item
                              label="State / Province"
                              prop="s1_province"
                            >
                              <el-input
                                v-model="formData.s1_province"
                                placeholder="please enter state / province"
                                clearable
                                :style="{ width: '100%' }"
                              >
                              </el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-col>
                      <el-col :span="6">
                        <el-row>
                          <el-col :span="22">
                            <el-form-item label="Zip Code" prop="s1_zip_code">
                              <el-input
                                v-model="formData.s1_zip_code"
                                placeholder="please enter zip code"
                                clearable
                                :style="{ width: '100%' }"
                              ></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-col>
                      <el-col :span="12">
                        <el-row>
                          <el-col :span="22">
                            <el-form-item
                              label="Company Website"
                              prop="s1_website"
                            >
                              <el-input
                                v-model="formData.s1_website"
                                placeholder="please enter company website"
                                clearable
                                :style="{ width: '100%' }"
                              ></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="16">
                    <el-row>
                      <el-col :span="12">
                        <el-row>
                          <el-col :span="22">
                            <el-form-item
                              label="Date of Formation"
                              prop="s1_formation_day"
                            >
                              <el-date-picker
                                v-model="formData.s1_formation_day"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                :style="{ width: '100%' }"
                                placeholder="please select date of formation"
                                clearable
                              ></el-date-picker>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-col>
                      <el-col :span="12">
                        <el-row>
                          <el-col :span="22">
                            <el-form-item label="Telephone" prop="s1_telephone">
                              <el-input
                                v-model="formData.s1_telephone"
                                placeholder="Telephone number"
                                clearable
                                :style="{ width: '100%' }"
                              ></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>

                <el-row :gutter="20" style="margin-top: 40px">
                  <el-col :span="6" :offset="0"></el-col>
                  <el-col :span="10" :offset="10">
                    <el-form-item size="large">
                      <el-button type="primary" @click="submitForm"
                        >Submit</el-button
                      >
                      <el-button @click="resetForm">Reset</el-button>
                    </el-form-item></el-col
                  >
                </el-row>
              </el-form>
            </div>
          </div>
        </el-card>
      </div>
    </div>
    <!-- <Footer /> -->
  </div>
</template>
<script>
import {
  otc_auth_status,
  get_info,
  att_info,
} from "../../plugins/api/account_otc";
import { countryOptions } from "../../plugins/data/form_base_data";
// import Footer from "../../components/Footer.vue";
export default {
  components: {}, // Footer
  props: [],
  data() {
    return {
      activeStep: 0,
      formData: {
        process: 1,
        s1_entity_legal_name: "",
        s1_entity_legal_id: "",
        s1_biz_address: "",
        s1_country: "",
        s1_city: "",
        s1_province: "",
        s1_zip_code: "",
        s1_formation_day: null,
        s1_telephone: "",
        s1_website: "",
      },
      rules: {
        s1_entity_legal_name: [
          {
            required: true,
            message: "Please enter your entity legal name",
            trigger: "blur",
          },
        ],
        s1_country: [
          {
            required: true,
            message: "Select or search country",
            trigger: "change",
          },
        ],
        s1_biz_address: [
          {
            required: true,
            message: "please enter addres",
            trigger: "blur",
          },
        ],
        s1_city: [
          {
            required: true,
            message: "please enter city",
            trigger: "blur",
          },
        ],
        s1_province: [
          {
            required: true,
            message: "please enter state / province",
            trigger: "blur",
          },
        ],
        s1_zip_code: [
          {
            required: true,
            message: "please enter zip code",
            trigger: "blur",
          },
        ],
        s1_formation_day: [
          {
            required: true,
            message: "please select date of formation",
            trigger: "change",
          },
        ],
        s1_telephone: [
          {
            required: true,
            message: "Telephone number",
            trigger: "blur",
          },
        ],
        s1_website: [
          {
            required: true,
            message: "please enter company website",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {},
  watch: {},
  created() {
    otc_auth_status().then((res) => {
      if (res && res.data) {
        // console.log("reg attach info complete!");
      }
    });

    get_info(
      `/account_otc/get_company_info?process=${this.formData.process}`
    ).then((res_query) => {
      if (res_query.data) {
        this.$Message.success("This information has been stored");
        this.formData = res_query.data;
      } else {
        // this.$alert(
        //   "Before you start trading, you need to refine your company Authentication Information",
        //   "prompt",
        //   {
        //     confirmButtonText: "Enter",
        //     callback: (action) => {},
        //   }
        // );
      }
    });
  },
  mounted() {},
  methods: {
    countryOptions() {
      return countryOptions;
    },
    submitForm() {
      this.$refs["elForm"].validate((valid) => {
        if (!valid) return;
        this.formData.process = 1;
        att_info("/account_otc/att_company_info", this.formData).then((res) => {
          console.log(res);
          if (res.code == 0 || res.code == 18289475) {
            this.$router.push("/reg/inc_cert/step2");
          } else {
            this.$message.error(res.msg);
          }
        });
        // TODO 提交表單
      });
    },
    resetForm() {
      this.$refs["elForm"].resetFields();
    },
  },
};
</script>
<style>
</style>
